import { render, staticRenderFns } from "./entities-menu.vue?vue&type=template&id=b9b684e0&"
import script from "./entities-menu.component.ts?vue&type=script&lang=ts&"
export * from "./entities-menu.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9b684e0')) {
      api.createRecord('b9b684e0', component.options)
    } else {
      api.reload('b9b684e0', component.options)
    }
    module.hot.accept("./entities-menu.vue?vue&type=template&id=b9b684e0&", function () {
      api.rerender('b9b684e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/entities/entities-menu.vue"
export default component.exports